import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/event-managements', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/event-managements', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/event-managements/${data.event_mgt_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const removeFile = (Options = {}) => {
  return httpClient
    .get('/api/event-managements/remove-files', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/event-managements/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const generateQr = (Options = {}) => {
  return httpClient
    .get('/api/event-managements/generate-qr', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/event-managements/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const eventManagementDetailExcel = data => {
  return httpClient
    .post('/api/event-managements/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const generateTicket = (Options = {}) => {
  return httpClient
    .get('/api/event-managements/generate-ticket', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const updateRegisteredStudentName = data => {
  return httpClient
    .put(`/api/event-management-registers/${data.registration_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  store,
  update,
  removeFile,
  destroy,
  generateQr,
  find,
  generateTicket,
  eventManagementDetailExcel,
  updateRegisteredStudentName
}
